/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';

export default function ChatBubble({ text = '', onDisappear }) {
  const [displayedText, setDisplayedText] = useState('');
  const [visible, setVisible] = useState(true);

  const onDisappearRef = useRef(onDisappear);

  useEffect(() => {
    onDisappearRef.current = onDisappear;
  }, [onDisappear]);

  useEffect(() => {
    setDisplayedText('');
    setVisible(true);

    if (!text) {
      const t = setTimeout(() => {
        setVisible(false);
        onDisappearRef.current?.();
      }, 1200);

      return () => clearTimeout(t);
    }

    let index = 0;

    const interval = setInterval(() => {
      index += 1;
      setDisplayedText(text.slice(0, index));

      if (index >= text.length) {
        clearInterval(interval);
      }
    }, 35);

    const timeout = setTimeout(() => {
      setVisible(false);
      onDisappearRef.current?.();
    }, 4000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [text]);

  if (!visible) return null;

  return (
    <motion.div
      className="speech-bubble"
      initial={{ opacity: 0, y: -20, scale: 0.96 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.45, ease: [0.55, 0.03, 0.22, 1] }}
    >
      <span className="typing-text">{displayedText}</span>
    </motion.div>
  );
}